import { useState } from "react";
import ServerRequests from "../../../../../../../Services/Api/ServersRequests.ts";
import { AddToastNotification } from "../../../../../../../Services/ToastNotification/ToastNotificationManager";
import IconButtons from "../../Components/IconButtons/IconButtons";
import { FaRunning, FaHeart, FaVolumeMute, FaVolumeDown, FaVolumeUp, FaCreditCard, FaSyringe } from "react-icons/fa";

const Administration = ({serverId, getPlayerIds}) => {
    const serverRequests = new ServerRequests();

    const [hp, setHp] = useState(null);

    const executeCommand = (command) => {
        serverRequests.ExecuteCommand(serverId, command, () => {
            AddToastNotification("Polecenie wysłane do wykonania!", 1);
        })
    }

    const executeCommandWithPlayers = (command, additionalData) => {
        const playerIds = getPlayerIds();

        if(playerIds.length > 0) {
            const commandToExecute = `/${command} ${playerIds} ${additionalData}`;
            executeCommand(commandToExecute);
        }
        else
        {
            AddToastNotification("Musisz wybrać graczy!", 0);
        }
    }

    const setPlayerHp = () => {
        if(hp){
            executeCommandWithPlayers("hp", hp)
        }else{
            AddToastNotification("Musisz ustawić HP!", 0);
        }
        
    }

    return (
        <>
            <h3 className="text-center">Select players from the list, then utilize any of the tools below.</h3>        
            <div className="flex mt-10">
                <IconButtons 
                    className="w-[50%]"
                    title={"Positioning Tools"}
                    buttons={
                        [
                            { onClick: () => executeCommandWithPlayers("noclip", "enable"), icon: <FaRunning color="rgb(67, 241, 95)" size={"50px"}/>, under: <><p>Noclip</p><p className="bg-glgreen mx-3 rounded-md mt-1">ON</p></> },
                            { onClick: () => executeCommandWithPlayers("noclip", "disable"), icon: <FaRunning color="rgb(255, 127, 127)" size={"50px"}/>, under: <><p>Noclip</p><p className="bg-glred mx-3 rounded-md mt-1">OFF</p></> }
                        ]}
                />
                <IconButtons 
                    className="w-[50%]"
                    title={"Godmode"}
                    buttons={
                        [
                            { onClick: () => executeCommandWithPlayers("god", "1"), icon: <FaHeart color="rgb(67, 241, 95)" size={"50px"}/>, under: <><p className="bg-glgreen mx-3 rounded-md mt-1">ON</p></> },
                            { onClick: () => executeCommandWithPlayers("god", "0"), icon: <FaHeart color="rgb(255, 127, 127)" size={"50px"}/>, under: <><p className="bg-glred mx-3 rounded-md mt-1">OFF</p></> }
                        ]}
                />               
            </div>   
            <div className="flex mt-10">
                <IconButtons 
                    className="w-[50%]"
                    title={"Intercom"}
                    buttons={
                        [
                            { onClick: () => executeCommand("/icomtimeout"), icon: <FaVolumeMute color="rgb(67, 241, 95)" size={"50px"}/>, under: <>Timeout</> },
                            { onClick: () => executeCommand("/icomreset"), icon: <FaVolumeDown color="rgb(255, 127, 127)" size={"50px"}/>, under: <>Reset</>  },
                            { onClick: () => executeCommandWithPlayers("icom", "1"), icon: <FaVolumeUp color="rgb(185, 119, 242)" size={"50px"}/>, under: <><p>Global</p> <p>Intercom</p><p className="bg-glgreen mx-3 rounded-md mt-1">ON</p></> },
                            { onClick: () => executeCommandWithPlayers("icom", "0"), icon: <FaVolumeUp color="rgb(255, 71, 71)" size={"50px"}/>, under: <><p>Global</p> <p>Intercom</p><p className="bg-glred mx-3 rounded-md mt-1">OFF</p></> }
                        ]}
                />     
                <IconButtons 
                    className="w-[50%]"
                    title={"Bypass"}
                    buttons={
                        [
                            { onClick: () => executeCommandWithPlayers("bypass", "1"), icon: <FaCreditCard color="rgb(67, 241, 95)" size={"50px"}/>, under: <p className="bg-glgreen mx-3 rounded-md mt-1">ON</p> },
                            { onClick: () => executeCommandWithPlayers("bypass", "0"), icon: <FaCreditCard color="rgb(255, 127, 127)" size={"50px"}/>, under: <p className="bg-glred mx-3 rounded-md mt-1">OFF</p> }
                        ]}
                />         
            </div>       
            <div className="flex mt-10 flex-row-reverse">
                <div className="w-[50%]">
                    <h3 className="text-center">Health Status</h3>
                    <div className="flex justify-center mb-3">
                        <input value={hp} onChange={(e) => setHp(e.target.value)} className="input" placeholder="Health amount" />
                    </div>
                    <IconButtons 
                        buttons={
                            [
                                { onClick: () => executeCommandWithPlayers("heal"), icon: <FaSyringe color="rgb(255, 150, 213)" size={"50px"}/>, under: <>Heal</> },
                                { onClick: () => setPlayerHp(), icon: <FaSyringe color="rgb(173, 224, 78)" size={"50px"}/>, under: <>Set HP</> }
                            ]}
                    />
                </div>
            </div>
        </>
    )
}

export default Administration;